import { connect } from 'react-redux';
import HeaderProfile from '../presentation/HeaderProfile';
import { logout } from '../actions/session';
import { getProfile } from 'actions/index';

const mapStateToProps = state => ({
  profile: state.profile,
  session: state.session,
  networkError: state.app.error,
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  getProfile: () => dispatch(getProfile())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderProfile);



// WEBPACK FOOTER //
// ./scripts/containers/HeaderProfileContainer.jsx